import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import * as treeFunc from "../../../services/ReportsTree";
let search = {
  FromAddress: null,
  ToAddress: null,
  StartDate: null,
  EndDate: null,
  ReceiveStatus: null,
  SendStatus: null,
  Mdn: null,
  OrganizationId: null,
  OrganizationName: null,
  MessageSource: "Sent",
  IncludeSubOrgs: false,
  DomainName: null,
  DomainId: null,
  VendorName: null,
  VendorId: null,
};
const SearchRecievedMessage = () => {
  const navigate = useNavigate();
  const { userToken, SetSharedObject, sharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [processing, SetProcessing] = useState(false);
  const [domainObj, SetDomainObj] = useState([]);
  const [orgBulkObj, SetOrgBulkObj] = useState([]);
  const [answers, setAnswers] = useState(search);
  const [custObj, SetCustObj] = useState([]);
  const [submFlag, setSubmFlag] = useState(false);
  const setAnswer = (questionId, answer) => {
   setAnswers((prev) => ({ ...prev, [questionId]: answer }));
  };
  const [domainName, setDomainName] = useState(null);
  const [domainId, setDomainId] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [vendorName, seVendorName] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [submInputFlag, setSubmitInputFlag] = useState(false);
  const [orgRequired, setOrgRequired] = useState(false);
  const [domainRequired, setDomainRequired] = useState(false);
  const [customerRequired, setCustomerRequired] = useState(false);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [orgTreeFilter, setOrgTreeFilter] = useState("");
  const [filteredOrgTree, setFilteredOrgTree] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("recievedMsgSearchModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  useEffect(() => {
    setSubmFlag(false);
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
        $("#endDate").datepicker("setDate", max);
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek());
    $("#endDate").datepicker("setDate", new Date());
    setEndDate(new Date(getLastWeek()));
    setStartDate(new Date());
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      getDomains();
    } else {
      let dmId = parseInt(userSession.domain_id);
      setDomainId(dmId);
      if (!isEmpty(sharedObject.RecievedSearchType))
        getOrgByVendors(userSession.vendor_id + "~List~" + dmId, true);
    }
  }, [sharedObject.RecievedSearchType]);
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const getDomains = async () => {
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      await { ...answers, VendorId: userSession.vendor_id };
    }
    SetProcessing(true);
    SetOrgBulkObj([]);
    let call = "/customers/GetUserDomains";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const obj = res.data.data.map((el) => ({
        ...el,
        show: true,
      }));
      SetDomainObj(obj);
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR" &&
        obj.length === 1
      ) {
        await { ...answers, DomainId: userSession.domain_id };
        getOrgByVendors(`${userSession.vendor_id}~List`);
      }
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  const getLastWeek = () => {
    let today = new Date();
    let lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7,
    );
    return lastWeek;
  };

  const getSubOrgList = async (parentId, parentName) => {
    SetProcessing(true);
    let model = { ParentOrganizationId: parentId };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, model, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let arr = res.data.data;
      let newArr = [];
      //let parentVal = { text: parentName, value: parentId, show: true };
      let parentVal = parseInt(parentId);
      newArr.push(parentVal);
      for (var i = 0; i < arr.length; i++) {
        //var val = { text: arr[i].name, value: arr[i].id, show: true };
        var val = arr[i].id;
        newArr.push(val);
      }
      return newArr;
    } else {
      return "error";
    }
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 30);
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    $("#endDate").datepicker("setStartDate", dt);
    $("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };
  const getMessages = async () => {
    setSubmFlag(true);
    setNoResults(false);
    let call =
      "/reports/GetMessageStatus?sortBy=DateSent&sortDir=DESC&type=received";
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    if (sharedObject.RecievedSearchType === "bulk") {
      if (checked.length === 0) {
        setOrgRequired(true);
        return;
      }
      const temp = [];
      checked.forEach((elem) => {
        let e = elem.split("~");
        let o = {
          Key: parseInt(e[0]),
          Value: e[1],
        };
        temp.push(o);
      });
      SetOrgBulkObj(temp);
    }
    const isDomainShown =
      userRole === "SES ADMINISTRATOR" ||
      (userRole === "SYSTEMADMINISTRATOR" && domainObj.length > 0);
    if (isDomainShown && !domainId) {
      setDomainRequired(true);
      return;
    }
    const isAdmin =
      userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR";
    if (isAdmin && !vendorName) {
      setCustomerRequired(true);
      return;
    }
    if (!organizationId && sharedObject.RecievedSearchType === "reg") {
      setOrgRequired(true);
      return;
    } else if (!startdate) {
      document.getElementById("startDate").scrollIntoView();
      document.getElementById("startDate").focus();
      return;
    } else if (!enddate) {
      document.getElementById("endDate").scrollIntoView();
      document.getElementById("endDate").focus();
      return;
    }

    let finalSearch = {
      FromAddress: answers.FromAddress,
      ToAddress: answers.ToAddress,
      ReceiveStatus: answers.ReceiveStatus,
      SendStatus: answers.SendStatus,
      Mdn: answers.Mdn,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
    };
    let refObj = {
      ...finalSearch,
    };
    if (sharedObject.RecievedSearchType === "bulk") {
      CloseSearchModal();
      $("#InputDownloadModalSearchRec").modal("show");
      setSubmitInputFlag(false);
      return;
    } else {
      if (answers.IncludeSubOrgs) {
        const subOrgList = await getSubOrgList(
          organizationId,
          organizationName,
        );
        if (subOrgList === "error") {
          console.log("Unable to get sub org list.");
          SetProcessing(false);
          return;
        }

        refObj = {
          ...finalSearch,
          OrganizationIds: subOrgList,
        };
      } else {
        var orgId = [parseInt(organizationId)];
        refObj = {
          ...finalSearch,
          OrganizationIds: orgId,
        };
      }
    }
    refObj = {
      ...refObj,
      DomainName: domainName,
      VendorName: vendorName,
    };
    SetProcessing(true);
    SetSharedObject("messageStatusSearch", refObj);
    const res = await CallAPI(call, refObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const results = res.data.data;
      const isEmpty =
        !results ||
        results.count === 0 ||
        !Array.isArray(results.pageItems) ||
        results.pageItems.length === 0;
      setNoResults(isEmpty);
      SetSharedObject("recievedMessageStatusResults", results);
      $("#recievedMsgSearchModal").modal("show");
      setAnswers((prev) => ({
        ...prev,
        BaseDomainId: "",
        VendorVal: "",
        Org: "",
      }));
      setDomainId(null);
      setDomainName(null);
      seVendorName(null);
      setOrganizationId(null);
      setOrganizationName(null);
      SetCustObj([]);
      if (
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR"
      ) {
        SetOrgObject([]);
      }
    } else {
      SetProcessing(false);
    }
  };

  const changeMDN = (e) => {
    let mdnString = e.target.value;
    let isMDN = null;
    if (mdnString === "All") {
      isMDN = null;
    } else if (mdnString === "true") {
      isMDN = true;
    } else if (mdnString === "false") {
      isMDN = false;
    }
    setAnswer("Mdn", isMDN);
  };

  const getVendorsByDomain = async (id) => {
    let dom = id.split("~");
    setDomainRequired(false);
    setDomainName(dom[1]);
    setDomainId(dom[0]);
    setAnswer("DomainId", dom[0]);
    SetProcessing(true);
    let call = "/admin/getVendorsByDomain?domainId=" + dom[0];
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let temp = [];
      if (res.data.data) {
        for (let el of res.data.data) {
          el.show = true;
          temp.push(el);
        }
      }
      SetCustObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    setAnswer("BaseDomainId", id);
  };
  const filterList = (val, list, setList, labelKey = "text") => {
    const updated = list.map((el) => {
      const label = el[labelKey]?.toLowerCase?.() || "";
      return {
        ...el,
        show: val.length > 1 ? label.includes(val.toLowerCase()) : true,
      };
    });
    setList(updated);
  };
  const filterDomains = (val) => filterList(val, domainObj, SetDomainObj);
  const filterOrganizations = (val) => filterList(val, orgObject, SetOrgObject);
  const filterVendors = (val) => filterList(val, custObj, SetCustObj);

  const [orgObject, SetOrgObject] = useState([]);
  const getOrgByVendors = async (val) => {
    let domId = val.split("~");
    setCustomerRequired(false);
    seVendorName(domId[1]);
    const domainNr = domId[2] ? domId[2] : domainId;
    await setAnswer("VendorId", parseInt(domId[0]));
    let call = null;
    if (sharedObject.RecievedSearchType === "reg") {
      let obj = sharedObject.getOrgsObj;
      let temp = [];
      if (obj) {
        for (let el of obj) {
          if (parseInt(domId[0]) === el.vendorId) {
            var o = { value: "", show: true, text: "" };
            o.value = el.id;
            o.text = el.name;
            temp.push(o);
          }
        }
      }
      SetOrgObject(temp);
    } else if (sharedObject.RecievedSearchType === "bulk") {
      let org = answers.OrganizationId
        ? parseInt(answers.OrganizationId)
        : userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
          ? parseInt(userSession.org_id)
          : "";
      let vendor = domId[0] ? parseInt(domId[0]) : "";
      let domain = answers.DomainId
        ? parseInt(answers.DomainId)
        : userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
          ? parseInt(userSession.domain_id)
          : "";
      call = "/organization/GetOrganizationTree?vendorId=" + vendor;
      var ob = { ...answers, VendorId: domId[0] };
      SetProcessing(true);
      const res = await CallAPI(call, ob, "post", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let obj = res.data.data.value?.orgNode;
        if (obj) {
          let o = treeFunc.treeObj(obj);
          SetOrgObject(o);
          SetProcessing(false);
        }
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }
    SetProcessing(false);
  };

  const QueueDownloadSearch = async () => {
    setSubmitInputFlag(true);
    if (newFileName === "" || hasInvalidChars) {
      return;
    }
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    let obj = {
      ...answers,
      DomainName: domainName,
      DomainId: null,
      OrganizationName: organizationName,
      VendorName: vendorName,
      OrganizationId: null,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
    };
    const newArray = orgBulkObj.filter((obj) => obj.Value !== "Root");
    let refObj = { ...obj, OrgList: JSON.stringify(newArray) };
    SetProcessing(true);
    let call =
      "/reports/ExportReceiveMessagesStatus?sortBy=SentDate&sortDir=SentDate&fileName=" +
      newFileName +
      "&reportType=1";
    const res = await CallAPI(call, refObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      SetCustObj([]);
      SetOrgObject([]);
      setAnswer("BaseDomainId", "");
      setSubmitInputFlag(false);
      setOrgRequired(false);
      CloseCreateFilenameModal();
      $("#downloadProgressModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.message;
      let str = "<div>";
      str += msg + "</div>";
      SetProcessing(false);
    }
  };

  useEffect(() => {
    if (orgTreeFilter.length > 1) {
      const filtered = filterTree(orgObject, orgTreeFilter);
      setFilteredOrgTree(filtered);
    } else {
      setFilteredOrgTree(orgObject);
    }
  }, [orgTreeFilter, orgObject]);

  const filterTree = (nodes, filterText) => {
    return nodes
      .map((node) => {
        if (
          node.label.toLowerCase().includes(filterText.toLowerCase()) ||
          (node.children && filterTree(node.children, filterText).length > 0)
        ) {
          return {
            ...node,
            children: node.children
              ? filterTree(node.children, filterText)
              : [],
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const collectAllValues = (nodes) => {
    const out = [];
    const walk = (arr) => {
      arr?.forEach((n) => {
        out.push(n.value);
        if (n.children?.length) walk(n.children);
      });
    };
    walk(orgObject);
    return out;
  };

  const getRootValue = () => orgObject?.[0]?.value;

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const invalidCharsRegex =
    /[\/\\|{}\[\]\(\)\*\%\$\#\@\!\^\&\?\<\>\:\;\"\'\=\+\,]/g;
  const hasInvalidChars = invalidCharsRegex.test(newFileName);
  useEffect(() => {
    const modalEl = $("#InputDownloadModalSearchRec");
    const handleModalClose = () => {
      setNewFileName("");
      setSubmitInputFlag(false);
    };

    modalEl.on("hidden.bs.modal", handleModalClose);

    return () => {
      modalEl.off("hidden.bs.modal", handleModalClose);
    };
  }, []);

  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $(`#${modalId}`).modal("hide");
  };

  const CloseSearchModal = () => closeModal("recievedMsgSearchModal");
  const CloseCreateFilenameModal = () =>
    closeModal("InputDownloadModalSearchRec");

  return (
    <>
      <div className="SearchSentMessage">
        <div
          className="modal fade"
          id="recievedMsgSearchModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="received-messagesearch-title"
          aria-describedby="receivedMessageSearchDesc"
          data-backdrop="static"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-slideout">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title spacer-inline text-size3">
                  {sharedObject.RecievedSearchType === "reg" ? (
                    <h2
                      className="modal-title spacer-inline text-size3"
                      id="received-messagesearch-title"
                    >
                      Search
                    </h2>
                  ) : (
                    <h2 className="modal-title spacer-inline"  id="received-messagesearch-title">
                      Download
                      <div className="text-size6 line-s1">Big Data</div>
                    </h2>
                  )}
                </div>
                {userRole === "SES ADMINISTRATOR" ||
                userRole === "SYSTEMADMINISTRATOR" ? (
                  <button
                    type="button"
                    className="close"
                    aria-label="Close search received message"
                    onClick={(e) => {
                      CloseSearchModal();
                      if (
                        userRole === "SES ADMINISTRATOR" ||
                        userRole === "SYSTEMADMINISTRATOR"
                      )
                        SetOrgObject([]);
                      SetCustObj([]);
                      setSubmitInputFlag(false);
                      setAnswer("BaseDomainId", "");
                      setOrgRequired(false);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="close"
                    aria-label="Close search received message"
                    onClick={(e) => {
                      CloseSearchModal();
                      setSubmitInputFlag(false);
                      setAnswer("BaseDomainId", "");
                      setOrgRequired(false);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                )}
              </div>
              <form aria-label="Search received messages">
                <div className="modal-body">
                    <p id="receivedMessageSearchDesc" className="sr-only">
                      Use this form to search or download received messages.
                      Fields marked with an asterisk are required.
                    </p>
                  <div className="modal-content-body container">
                    {/*SES Admin only Domain*/}
                    {userRole === "SES ADMINISTRATOR" ||
                    (userRole === "SYSTEMADMINISTRATOR" &&
                      domainObj.length > 0) ? (
                      <div className="field-wrapper">
                        <label htmlFor="domainSelect">
                            Domain
                            <span aria-hidden="true" className="rd-clr"> *</span>
                       </label>
                        <span className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter domains"
                            onChange={(el) => filterDomains(el.target.value)}
                          />
                        </span>
                        <select
                          className="form-control"
                          name="DomainId"
                          id="domainSelect"
                          size="4"
                          aria-label="Select domain"
                          value={answers.BaseDomainId}
                          onChange={(el) => {
                            if (el.target.value !== "") {
                              SetOrgObject([]);
                              getVendorsByDomain(el.target.value);
                            }
                          }}
                        >
                          <option value="">Select Domain</option>
                          {domainObj?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                        {submFlag && domainRequired ? (
                          <div
                            className="alert alert-danger"
                            role="alert"
                            aria-live="assertive"
                            aria-atomic="true"
                          >
                            Domain is required.
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {userRole === "SES ADMINISTRATOR" ||
                    userRole === "SYSTEMADMINISTRATOR" ? (
                      <div className="field-wrapper">
                        <label htmlFor="customerSelect">
                            Customer
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <span className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter customers"
                            onChange={(el) => filterVendors(el.target.value)}
                          />
                        </span>
                        <select
                          size="4"
                          className="form-control"
                          name="VendorName"
                          id="customerSelect"
                          value={answers?.VendorVal || ""}
                          onChange={(el) => {
                            if (el.target.value !== "") {
                              setAnswer("VendorVal", el.target.value);
                              getOrgByVendors(el.target.value);
                            }
                          }}
                        >
                          <option value="">Select Customer</option>
                          {custObj?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                        {submFlag && customerRequired ? (
                          <div
                            className="alert alert-danger"
                            role="alert"
                            aria-live="assertive"
                            aria-atomic="true"
                          >
                            Customer is required.
                          </div>
                        ) : null}
                      </div>
                    ) : null}

                    {/*Organization*/}
                    <div>
                      <label htmlFor="organizationSelect">
                        Organization
                        <span aria-hidden="true" className="rd-clr"> *</span>
                     </label>
                      {sharedObject.RecievedSearchType === "reg" ? (
                        <div className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter organizations"
                            onChange={(el) =>
                              filterOrganizations(el.target.value)
                            }
                          />
                        </div>
                      ) : null}
                      {orgObject.length === 0 ? (
                        <div className="watermark-wrapper sp-margin16" role="status" aria-live="polite" aria-atomic="true">
                          No Results
                        </div>
                      ) : sharedObject.RecievedSearchType === "reg" ? (
                        <select
                          className="form-control"
                          size="4"
                          name="OrganizationId"
                          id="organizationSelect"
                          value={answers?.Org}
                          onChange={(el) => {
                            let val = el.target.value;
                            if (val !== "") {
                              setOrgRequired(false);
                              let domId = val.split("~");
                              setOrganizationName(domId[1]);
                              setOrganizationId(domId[0]);
                              setAnswer("Org", val);
                            }
                          }}
                        >
                          <option value="">Select Organization</option>
                          {orgObject?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                      ) : (
                        <div>
                          <span className="treefilter-wrapper filter-container dg-clr spacer-margin8">
                            <input
                              type="text"
                              className="form-control filter-sm pr-4 pos-1"
                              aria-label="Filter organization tree"
                              placeholder="Filter"
                              value={orgTreeFilter}
                              onChange={(e) => setOrgTreeFilter(e.target.value)}
                            />
                            {orgTreeFilter && (
                              <button
                                type="button"
                                onClick={() => setOrgTreeFilter("")}
                                className="clear-button"
                                aria-label="Clear organization filter"
                              >
                                <i className="bi bi-x" aria-hidden="true"></i>
                              </button>
                            )}
                          </span>
                          <CheckboxTree
                            nodes={filteredOrgTree}
                            checked={checked}
                            expanded={expanded}
                            onCheck={(nextChecked) => {
                              const rootVal = getRootValue();
                              const wasRootChecked = checked?.includes(rootVal);
                              const isRootChecked =
                                nextChecked?.includes(rootVal);

                              if (!wasRootChecked && isRootChecked) {
                                setChecked(collectAllValues(orgObject));
                              } else if (wasRootChecked && !isRootChecked) {
                                setChecked([]);
                              } else {
                                setChecked(nextChecked);
                              }
                            }}
                            onExpand={setExpanded}
                            noCascade={true}
                            showExpandAll={true}
                          />
                        </div>
                      )}
                      {submFlag && orgRequired ? (
                        <div id="OrganizationAlert" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Organization is required.
                        </div>
                      ) : null}
                    </div>
                    {sharedObject.RecievedSearchType === "reg" ? (
                      <div className="spacer-margin3">
                      <label htmlFor="includeSubOrgs" className="label-sub d-flex align-items-center gap-2 sp-margin3">
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          id="includeSubOrgs"
                          value={answers.IncludeSubOrgs}
                          onChange={(el) => {
                            setAnswer("IncludeSubOrgs", el.target.checked);
                          }}
                        />
                          Include Sub Organizations
                        </label>
                      </div>
                    ) : null}

                    {/*Sent To*/}
                    <div className="field-wrapper">
                      <label htmlFor="SentTo">To</label>
                      <input
                        type="email"
                        className="form-control"
                        name="SentTo"
                        id="SentTo"
                        autoComplete="off"
                        placeholder="Enter Direct Email"
                        value={answers.ToAddress}
                        onChange={(e) => setAnswer("ToAddress", e.target.value)}
                      />
                    </div>
                    {/*Sent From*/}
                    <div className="field-wrapper">
                      <label htmlFor="SentFrom">From</label>
                      <input
                        type="email"
                        className="form-control"
                        name="SentFrom"
                        id="SentFrom"
                        autoComplete="off"
                        placeholder="Enter Direct Email"
                        value={answers.FromAddress}
                        onChange={(e) =>
                          setAnswer("FromAddress", e.target.value)
                        }
                      />
                    </div>
                    <div className="field-wrapper">
                      {/*Start Date*/}
                      <div className="spacer-margin5 spacer-inline w-md2 v-top">
                        <label htmlFor="startDateInput">
                            Start Date
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          id="startDate"
                          data-date-end-date="1d"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="StartDate"
                            id="startDateInput"
                            autoComplete="off"
                            aria-required="true"
                          />
                          <div className="input-group-append">
                            <button
                               type="button"
                                className="input-group-text" 
                                id="startDateButton"
                                aria-label="Open start date calendar"
                             >
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        {submFlag && !startdate ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">Start date is required.</div>
                        ) : null}
                      </div>

                      {/*End Date*/}
                      <div className="spacer-inline w-md2 v-top">
                        <label htmlFor="endDateInput">
                            End Date
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <div
                          className="input-group date end-date"
                          data-provide="datepicker"
                          id="endDate"
                          data-date-start-date={minDate}
                          data-date-end-date={maxDate}
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="EndDate"
                            id="endDateInput"
                            autoComplete="off"
                            aria-required="true"
                          />
                          <div className="input-group-append">
                            <button 
                                type="button"
                                className="input-group-text" 
                                id="endDateButton" 
                                aria-label="Open end date calendar" 
                            >
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        {submFlag && !enddate ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">End date is required.</div>
                        ) : null}
                      </div>
                      <div className="descript-container sp-margin13">
                        Set a date range to specify results within 1 month.
                      </div>
                    </div>
                    {/*MDN*/}
                    <div className="field-wrapper w-md2 spacer-inline spacer-margin5">
                      <label htmlFor="MessageType">Message Type</label>
                      <select
                        className="form-control"
                        name="MessageType"
                        id="MessageType"    
                        value={answers.Mdn}
                        onChange={(e) => changeMDN(e)}
                        aria-label="Message Disposition Notification"
                      >
                        <option value="All">All</option>
                        <option value={true}>MDN</option>
                        <option value={false}>Not MDN</option>
                      </select>
                    </div>
                    {/*Status*/}
                    <div className="field-wrapper w-md2 spacer-inline">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        id="status"
                        value={answers.ReceiveStatus}
                        onChange={(el) =>
                          setAnswer("ReceiveStatus", el.target.value)
                        }
                      >
                        <option value="All">All</option>
                        <option value="Accepted">Accepted</option>
                        <option value="Confirmed">Confirmed</option>
                        <option value="Failed">Failed</option>
                      </select>
                    </div>
                    {noResults ? (
                      <div
                        className="alert alert-secondary"
                        role="alert"
                        aria-live="polite"
                        aria-atomic="true"
                      >
                        We did not find any results based on your criteria.
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => getMessages()}
                    ref={firstFocusRef}
                  >
                    {sharedObject.RecievedSearchType === "reg"
                      ? "Search"
                      : "Continue"}
                  </button>
                  {userRole === "SES ADMINISTRATOR" ||
                  userRole === "SYSTEMADMINISTRATOR" ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => {
                        CloseSearchModal();
                        SetCustObj([]);
                        if (
                          userRole === "SES ADMINISTRATOR" ||
                          userRole === "SYSTEMADMINISTRATOR"
                        )
                          SetOrgObject([]);
                        setSubmitInputFlag(false);
                        setAnswer("BaseDomainId", "");
                        setOrgRequired(false);
                      }}
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => {
                        CloseSearchModal();
                        setSubmitInputFlag(false);
                        setAnswer("BaseDomainId", "");
                        setOrgRequired(false);
                      }}
                    >
                      Cancel
                    </button>
                  )}
                  {processing && (
                    <div 
                        className="loader-container" 
                        role="status" 
                        aria-live="polite" 
                        aria-atomic="true"
                        aria-labelledby="search-receivedmessage-loader"
                    >
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text" id="search-receivedmessage-loader">{loadingText}</div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="InputDownloadModalSearchRec"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="create-filename-title"
        aria-describedby="CreateFilenameDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="create-filename-title">
                Download Filename
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close Create Filename Modal"
                onClick={CloseCreateFilenameModal}
                disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-body">
                <p className="descript-container" id="CreateFilenameDesc">
                  Enter a new name to identify your download file once it has
                  been queued in the download status page.
                </p>
                <div className="modal-content-form">
                  <label htmlFor="NewFileName">Create a new filename</label>
                  <input
                    type="text"
                    className="form-control"
                    name="NewFileName"
                    id="NewFileName"
                    autoComplete="off"
                    value={newFileName}
                    onChange={(el) => setNewFileName(el.target.value)}
                  />
                  {submInputFlag && newFileName === "" && (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                      Filename is required
                    </div>
                  )}

                  {submInputFlag && hasInvalidChars && (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                      Please remove any special characters.
                    </div>
                  )}

                  <div className="field-wrapper sp-margin3 descript-container">
                    Downloading may take several minutes to hours depending on
                    the number of records and timeframe of the report.
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={QueueDownloadSearch}
                disabled={processing}
                aria-label="Queue Download"
              >
                {processing ? "Processing..." : "Queue Download"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseCreateFilenameModal}
                disabled={processing}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchRecievedMessage;
